



<!-- detail station -->
<div class="row justify-content-center mt-3">


    <div class="col-10 col-lg-11">

            <div class="d-flex align-items-center mb-3">
                <button *ngIf="siteType === 'default'" mat-stroked-button color="primary" class="btn-retour" (click)="goBack()">
                    <mat-icon class="mr-2">arrow_back</mat-icon>
                    Retour
                </button>
                <button *ngIf="siteType === 'remi'" mat-stroked-button color="primary" class="btn-remi" (click)="goBack()">
                    <mat-icon class="mr-2">arrow_back</mat-icon>
                    Retour
                </button>
            </div>
    </div>


    <mat-card *ngIf="currentUser" class="col-10 col-lg-11 bordure mat-elevation-z8">
        <mat-card-content>
            <h2 class="text-center font-weight-bold  mb-2">Mes réservations partageable</h2>

            <!-- Resa -->
            <div class="row justify-content-center mt-3 mb-3">

                <div *ngFor="let item of reservations;let index = index" class="col-10 col-lg-10">
                    <div class="row justify-content-center mt-3 p-2"
                        style="border: solid #696969; border-radius: 12px;">

                        <div class="col-12 col-lg-7 mt-3">
                            <h4> <span class="font-weight-bold">Emplacement: </span>{{item?.station_name}}</h4>
                            <h4 *ngIf="item.covoiturage.destination">
                                <span class="font-weight-bold">Déstination: </span>
                                {{item?.covoiturage?.destination}}
                            </h4>
                            <div *ngIf="isShareTrajet === true && item?.covoiturage.share === true"
                                class="row justify-content-center">
                                <mat-form-field class="col-12 col-lg-7">
                                    <input matInput placeholder="Déstination :"
                                        [(ngModel)]="item.covoiturage.destination">
                                </mat-form-field>
                            </div>
                            <div *ngIf="isUpdateTrajet === true  && item?.covoiturage.update === true"
                                class="row justify-content-center">
                                <mat-form-field class="col-12 col-lg-7">
                                    <input matInput placeholder="Déstination :"
                                        [(ngModel)]="item.covoiturage.destination">
                                </mat-form-field>
                            </div>
                            <button *ngIf="isShareTrajet === false && item.covoiturage.destination === undefined"
                                class="my-1 mx-1 bleu-clair-bouton" mat-raised-button color="primary"
                                (click)="partageTrajet(item)" type="submit">Partager mon trajet</button>

                            <button
                                *ngIf="isUpdateTrajet === false && item.covoiturage.destination && item.covoiturage.share !== true"
                                class="my-1 mx-1 bleu-clair-bouton" mat-raised-button color="primary"
                                (click)="updateTrajetCovoiturage(item)" type="submit">Modifier</button>

                            <button *ngIf="isShareTrajet === true && item.covoiturage.share === true"
                                class="my-1 mx-1 bleu-clair-bouton" mat-raised-button color="primary"
                                (click)="createCovoiturage(item)" type="submit">Valider</button>
                            <button *ngIf="isUpdateTrajet === true && item.covoiturage.update === true"
                                class="my-1 mx-1 bleu-clair-bouton" mat-raised-button color="primary"
                                (click)="updateCovoiturage(item)" type="submit">Valider la modification</button>

                        </div>
                        <div class="col-12 col-lg-5 mt-3">
                            <h4> <span class="font-weight-bold">Début: </span>{{getDateFormat(item?.startdate)}}</h4>
                            <h4 *ngIf="item.covoiturage.destination">
                                <span class="font-weight-bold">Nombre de place dispo:
                                </span>{{item?.covoiturage?.nbplace}}
                            </h4>
                            <div *ngIf="isShareTrajet === true && item?.covoiturage.share === true"
                                class="row justify-content-center">
                                <mat-form-field class="col-12 col-lg-7">
                                    <input matInput type="number" max="3" min="0" placeholder="Nombre de place dispo :"
                                        [(ngModel)]="item.covoiturage.nbplace">
                                </mat-form-field>
                            </div>
                            <div *ngIf="isUpdateTrajet === true && item?.covoiturage.update === true"
                                class="row justify-content-center">
                                <mat-form-field class="col-12 col-lg-7">
                                    <input matInput type="number" max="3" min="0" placeholder="Nombre de place dispo :"
                                        [(ngModel)]="item.covoiturage.nbplace">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                </div>
            </div>




        </mat-card-content>
    </mat-card>



    <mat-card class="col-10 col-lg-11 bordure mat-elevation-z8 mt-5 mb-4">
        <mat-card-content>
            <h2 class="text-center font-weight-bold  mb-2">Covoiturages</h2>
            <!-- Resa -->


            <!-- card search -->
            <div class="row justify-content-center  my-4">

                <mat-accordion class="col-12 col-md-8">
                    <mat-expansion-panel class="my-4">
                        <mat-expansion-panel-header class="search">
                            <mat-panel-title>
                                <div class="row ml-2">
                                    <div>
                                        <mat-icon class="mx-2" aria-hidden="false"
                                            aria-label="Example home icon">electric_car</mat-icon>
                                    </div>
                                    <div>
                                        <p class="">Rechercher des emplacements</p>
                                    </div>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="row justify-content-center">

                            <!-- Emplacement -->
                            <mat-form-field class="col-md-9">
                                <mat-label>Emplacement :</mat-label>
                                <input matInput [matAutocomplete]="auto" #filterStation [formControl]="stateCtrl">
                                <mat-autocomplete (optionSelected)="onStationChanged($event)" #auto="matAutocomplete">
                                    <mat-option *ngFor="let state of filteredStates | async" [value]="state.name">
                                        <span style="font-size: 13px">{{state.name}}</span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>

                        <div class="row justify-content-center mt-2">
                            <button mat-raised-button color="primary" class="mr-3 primary-bouton"
                                (click)="filterCovoiturages()" type="submit">Rechercher</button>
                            <button mat-raised-button color="primary" class="primary-bouton"
                                (click)="reset()">Effacer</button>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>



            <div class="table-responsive">

                <!-- <mat-progress-bar *ngIf="IsWaitbar === true" class="col-12" mode="indeterminate"></mat-progress-bar> -->

                <table class="table-hover" mat-table [dataSource]="covoiturages">


                    <!-- debut Column -->
                    <ng-container matColumnDef="debut">
                        <th style="min-width: 190px;" mat-header-cell *matHeaderCellDef class="text-center bloc">
                            Date début </th>
                        <td style="min-width: 190px;" mat-cell *matCellDef="let element" class="text-center">
                            {{getDateFormat(element?.startdate)}} </td>
                    </ng-container>

                    <!-- emplacement Column -->
                    <ng-container matColumnDef="emplacement">
                        <th style="min-width: 330px;" mat-header-cell *matHeaderCellDef class="text-center bloc">
                            Emplacement </th>
                        <td style="min-width: 330px;" mat-cell *matCellDef="let element" class="text-center">
                            {{element.station_name}} </td>
                    </ng-container>

                    <!-- destination Column -->
                    <ng-container matColumnDef="destination">
                        <th style="min-width: 330px;" mat-header-cell *matHeaderCellDef class="text-center bloc">
                            Déstination </th>
                        <td style="min-width: 330px;" mat-cell *matCellDef="let element" class="text-center">
                            {{element?.destination}} </td>
                    </ng-container>

                    <!-- place Column -->
                    <ng-container matColumnDef="place">
                        <th style="min-width: 90px;" mat-header-cell *matHeaderCellDef class="text-center bloc">
                            Places </th>
                        <td style="min-width: 90px;" mat-cell *matCellDef="let element" class="text-center ">
                            {{element.nbplace}}
                        </td>

                    </ng-container>


                    <!-- covoiturer Column -->
                    <ng-container matColumnDef="covoiturer">
                        <th style="min-width: 50px;" mat-header-cell *matHeaderCellDef class="text-center bloc">
                            Covoiturer </th>
                        <td style="min-width: 50px;" mat-cell *matCellDef="let element" class="text-center ">
                            <button class="primary-bouton" mat-raised-button color="primary"
                                (click)="detailCovoiturage(element)">
                                accéder
                            </button>
                        </td>
                    </ng-container>


    

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
               

                </table>

                <div class="mx-5 my-4" *ngIf="covoiturages.length === 0"> <p>Pas de covoiturages sur cet emplacement</p></div>



            </div>


            <mat-paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10,20,50,100]"
                [showFirstLastButtons]="true" (page)="handlePage($event)">
            </mat-paginator>



        </mat-card-content>
    </mat-card>
</div>